<script>
    export let id;

    export let picture;
    export let picHeight = 0;
    export let picWidth = 0;

    export let height = 100;
    export let width = 100;

    export let y = 0;
    export let x = 0;

    export let shiftY = 0;
    export let shiftX = 0;

    export let shiftYKoef = 1;
    export let shiftXKoef = 1;

    let picLeft = 0,
        picTop = 0;

    $: {
        if (picture && picHeight && picWidth) {
            picLeft = -(x / 100) * picWidth;
            picTop = -(y / 100) * picHeight;
        }
    }
</script>

<span
    class="module-calc-modules-part"
    style={`height: ${height}%; width: ${width}%; top: ${parseFloat(y) + parseFloat(shiftY) * shiftYKoef}%; left: ${parseFloat(x) + parseFloat(shiftX) * shiftXKoef}%;
    background-image: url(${picture}); background-repeat: no-repeat;
    background-position: ${picLeft}px ${picTop}px;
    background-size: ${picWidth}px ${picHeight}px
    `}
>
</span>
